import { Button, Input } from '@you/ui'
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useCaptchaLogin } from '@/api/hooks/useUser'

interface PhoneLoginFormProps {
  idPrefix?: string
}

export const PhoneLoginForm = ({ idPrefix = '' }: PhoneLoginFormProps) => {
  const [phone, setPhone] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  const [countdown, setCountdown] = useState(0)
  const [errors, setErrors] = useState<{
    phone?: string
    verificationCode?: string
    api?: string
  }>({})

  const navigate = useNavigate()
  const location = useLocation()
  const {
    trigger: login,
    isMutating: isLoggingIn,
    // error: loginError,
  } = useCaptchaLogin()

  const handleSendCode = () => {
    if (!phone) {
      setErrors((prev) => ({ ...prev, phone: '请输入手机号' }))
      return
    }
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      setErrors((prev) => ({ ...prev, phone: '请输入正确的手机号' }))
      return
    }

    setErrors({}) // Clear previous errors
    // TODO: Call the actual send captcha API
    console.log('发送验证码到:', phone)
    setCountdown(60)
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const newErrors: {
      phone?: string
      verificationCode?: string
    } = {}

    if (!phone) {
      newErrors.phone = '请输入手机号'
    } else if (!/^1[3-9]\d{9}$/.test(phone)) {
      newErrors.phone = '请输入正确的手机号'
    }
    if (!verificationCode) {
      newErrors.verificationCode = '请输入验证码'
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    try {
      await login({
        mobile: phone,
        captcha: verificationCode,
      })

      // 获取登录前的页面路径（如果有）
      const from = (location.state as any)?.from?.pathname || '/'
      console.log('登录成功，重定向到:', from)
      navigate(from, { replace: true })
    } catch (e) {
      // The hook's error state will be set, we can display it
      console.error('Login failed', e)
    }
  }

  // 检查表单是否可以提交
  const isFormValid = phone.trim() !== '' && verificationCode.trim() !== ''

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="space-y-4">
        <div>
          <label htmlFor={`${idPrefix}phone`} className="sr-only">
            手机号
          </label>
          <Input
            id={`${idPrefix}phone`}
            name="phone"
            type="tel"
            autoComplete="tel"
            placeholder="请输入手机号"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value)
              if (errors.phone) {
                setErrors((prev) => ({ ...prev, phone: undefined }))
              }
            }}
            error={!!errors.phone}
            errorMessage={errors.phone}
          />
        </div>
        <div className="flex gap-4">
          <div className="flex-1">
            <label htmlFor={`${idPrefix}verificationCode`} className="sr-only">
              验证码
            </label>
            <Input
              id={`${idPrefix}verificationCode`}
              name="verificationCode"
              type="text"
              placeholder="请输入验证码（3x..）"
              value={verificationCode}
              onChange={(e) => {
                setVerificationCode(e.target.value)
                if (errors.verificationCode) {
                  setErrors((prev) => ({
                    ...prev,
                    verificationCode: undefined,
                  }))
                }
              }}
              error={!!errors.verificationCode}
              errorMessage={errors.verificationCode}
            />
          </div>
          <Button
            type="button"
            className="w-[120px] h-[36px] text-[14px] rounded-[99px] bg-gradient-primary disabled:opacity-50"
            onClick={handleSendCode}
            disabled={countdown > 0}
          >
            {countdown > 0 ? `${countdown}秒后重试` : '发送验证码'}
          </Button>
        </div>
        {/* {loginError && (
          <p className="text-red-500 text-sm text-center">
            {loginError.message || '登录失败，请重试'}
          </p>
        )} */}
      </div>
      <div className="flex flex-col items-center space-y-6">
        <Button
          className="w-[298px] h-[50px] text-[16px] rounded-[99px] bg-gradient-primary"
          type="submit"
          disabled={!isFormValid || isLoggingIn}
        >
          {isLoggingIn ? '登录中...' : '登录'}
        </Button>
      </div>
    </form>
  )
}
